//import axios from 'axios';
import Api from './Api';
import store from '../store.js';
import ConfigService from './ConfigService.js';

// function generateHeaders() {
//     if(store.state.auth.userInfo) {
//         return {'X-UserName': store.state.auth.username, 'X-Password': store.state.auth.password, 'X-UserType': 'Customer'};
//     }
//     else{
//         return {};
//     }
// }

// const ALL_PRODUCTS_ROOT_CATEGORIES = [
//   "Stationary",
//   "Liquor and Gaming",
//   "Packaging",
//   "Wristbands"
// ];


function getBaseURL(category)
{
    var baseUrl = process.env.CUSTOMER_PRODUCT_API_ENDPOINT;

    if(category && isChildOfShowAllRootCategory(category)) {
        baseUrl = process.env.PUBLIC_PRODUCT_API_ENDPOINT;
    }

    return baseUrl;
}

export function isChildOfShowAllRootCategory(cat) {
    if(!cat) {
        return false;
    }
    if(cat.ShowAllProducts) {
        return true;
    }
    if(cat.ParentCategory) {
        return isChildOfShowAllRootCategory(cat.ParentCategory);
    }
    return false;
    // return ALL_PRODUCTS_ROOT_CATEGORIES.some(c => cat.FullName.toLowerCase().startsWith(c.toLowerCase() + "/"));
}
function stringSort(a, b){
  if(a == b) return 0;
  if(a == undefined) return -1;
  if(b == undefined) return 1;

  var upperA = a.toUpperCase();
  var upperB = b.toUpperCase();

  if(upperA < upperB) return -1;
  if(upperA > upperB) return 1;
  return 0;
}

export default {
    searchResults: [],
    lastSearchTerm: '',
    async ProductSearch(searchTerm, skip, take) {
        if(searchTerm != this.lastSearchTerm) {
            this.lastSearchTerm = searchTerm;

            var productCriteria = `(Contains(Name, '${searchTerm}') OR Contains(Description, '${searchTerm}')) And !IsNull(ProductCategory) And (ProductCategory.ShowAllProducts Or (!IsNull(ProductCategory.Parent) And ProductCategory.Parent.ShowAllProducts))`;
            var productUrl = process.env.PUBLIC_PRODUCT_API_ENDPOINT + "&OrderBy=Name&skip=0&take=0&criteria=" + encodeURIComponent(productCriteria);
            var res2 = await Api.get(productUrl);

            var priceListCriteria = `(Contains(ProductService.Name, '${searchTerm}') OR Contains(ProductService.Description, '${searchTerm}')) And !IsNull(ProductService.ProductCategory)`;
            var priceListUrl = process.env.CUSTOMER_PRODUCT_API_ENDPOINT + "&OrderBy=ProductService.Name&skip=0&take=0&criteria=" + encodeURIComponent(priceListCriteria);
            var res1 = await Api.get(priceListUrl);
            // var res1 = {};

            var allResp = (res1.data || []).concat(res2.data || []);

            var res = allResp.filter((el,i,arr) => arr.findIndex(id => el.ItemNumber == id.ItemNumber) === i).sort((a,b) => stringSort(a.Name, b.Name));
            this.searchResults =  res;
        }

        return this.searchResults.slice(skip, skip+take);
    },
    GetHistory(companyOid) {
        var baseUrl = process.env.CUSTOMER_HIST_API_ENDPOINT;
        var url = baseUrl + "&c=" + companyOid;
        return Api.get(url);
    },
    GetProducts(criteria, orderBy, skip, take, category) {
        
        var baseUrl = getBaseURL(category);
        var urlAddon = "&OrderBy=" + orderBy + "&skip=" + skip + "&take=" + take;

        if(criteria) {
            urlAddon = urlAddon + '&criteria=' + encodeURIComponent(criteria);
        }
        
        var url = baseUrl + urlAddon;

        return Api.get(url);
    },
    // GetPrice(productKey) {
    //     var baseUrl = process.env.CUSTOMER_PRODUCT_API_ENDPOINT;
    //     baseUrl += "&criteria=" + encodeURIComponent(`ProductService.Oid = '${productKey}'`);
        
    //     return Api.get(baseUrl);
    // },
    GetFeaturedProducts(orderBy) {

        var criteria = "[Tags][Name = 'Featured']";

        if(store.state.auth.userInfo) {
            criteria = "[ProductService.Tags][Name = 'Featured']";
        }

        return this.GetProducts(criteria, orderBy, 0, 3);
    },
    GetByKey(key) {
        var url = getBaseURL() + "&key=" + key;
        return Api.get(url);
    },
    async GetByItemNumber(item) {

        var cat = item.ProductCategory;
        if(typeof cat === 'string') {
            cat = await ConfigService.GetCategoryByFullName(item.ProductCategory);
        }
        if(!cat || typeof cat === 'string') {
            debugger;
        }

        var criteria = "ItemNumber = '"+item.ItemNumber+"'";

        if(store.state.auth.userInfo && !isChildOfShowAllRootCategory(cat)) {
            criteria = "ProductService." + criteria;
        }

        var url = getBaseURL(cat) + "&criteria=" + encodeURIComponent(criteria);
        return Api.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/ProductService.js